import type {NamespaceConfigs, ComponentFeatures} from '@wix/document-services-types'
import type {ComponentsMetadata} from './types'
import {default as DATA_TYPES_JSON} from '../constants/DATA_TYPES.json'
import {default as VARIANTS_DATA_TYPES_JSON} from '../constants/VARIANTS_DATA_TYPES.json'
import {default as NAMESPACE_CONFIGS_JSON} from '../constants/NAMESPACE_CONFIGS.json'
import {default as COMPONENTS_METADATA_JSON} from '../constants/COMPONENTS_METADATA.json'
import {default as COMPONENT_FEATURES_JSON} from '../constants/COMPONENT_FEATURES.json'

export {schemaService} from './schemaService'

export const DATA_TYPES = DATA_TYPES_JSON
export const VARIANTS_DATA_TYPES = VARIANTS_DATA_TYPES_JSON
export const NAMESPACE_CONFIGS = NAMESPACE_CONFIGS_JSON as unknown as NamespaceConfigs
export const COMPONENTS_METADATA = COMPONENTS_METADATA_JSON as unknown as ComponentsMetadata
export const COMPONENT_FEATURES = COMPONENT_FEATURES_JSON as unknown as ComponentFeatures
